<template>
  <option class="cv-select-option bx--select-option">
    <slot></slot>
  </option>
</template>

<script>
export default {
  name: 'CvSelectOption',
  // HTML props disabled selected hidden
};
</script>
